import { API_BASE } from '../config';

/**
 * Fetch wrapper that automatically adds JWT token from localStorage
 * @param {string} path - API endpoint path (e.g., '/api/products')
 * @param {RequestInit} opts - Fetch options
 * @returns {Promise<Response>}
 */
export const apiFetch = (path, opts = {}) => {
  const token = localStorage.getItem('tms_token');
  const headers = {
    ...(opts.headers || {}),
    ...(token ? { Authorization: 'Bearer ' + token } : {})
  };
  return fetch(API_BASE + path, { ...opts, headers });
};
